import { Injectable } from '@angular/core';
import { Platform } from '@ionic/angular';
import { Capacitor } from '@capacitor/core';
@Injectable({
  providedIn: 'root'
})
export class MobileResponsiveService {
  hideForTabletAndBelow = false;
  hideForMobile = false;
  ifIsIosMobOrTabDevice = false;
  getIfWebLogin = false;

  modelMaxWidthIfScreenSize!: string;
  modelMaxWidth1300AndBelow!: string;
  modelMaxWidth1200AndBelow!: string;
  modelMaxWidth992AndBelow!: string;

  modelMaxWidthForMobileDevice!: string;
  modelWidthForMobileDevice!: string;

  graphWidthForMobileDevice!: string;

  minScreenSize = {
    xxl1400: { size: 1400, value: '1400px' },
    xxl1300: { size: 1300, value: '1200px' },
    xl1200: { size: 1200, value: '1140px' },
    lg992: { size: 992, value: '960px' },
    md768: { size: 768, value: '720px' },
    sm576: { size: 576, value: '540px' },
    defaultMobile: { size: 300, value: '100%' }
  };

  maxScreenSize = {
    xxl1400: { size: '1399.98', value: '1320px' },
    xxl1300: { size: '1299.98', value: '1220px' },
    xl1200: { size: '1199.98', value: '1140px' },
    lg992: { size: '991.98', value: '960px' },
    md768: { size: '767.98', value: '720px' },
    sm576: { size: '575.98', value: '540px' },
    defaultMobile: { size: '', value: '100%' }
  };

  constructor(public platform: Platform) {
    if (Capacitor.getPlatform() === 'web') this.getIfWebLogin = true;
    if (this.platform.is('ios') || this.platform.is('ipad')) this.ifIsIosMobOrTabDevice = true;

    const windowWidth = window.innerWidth;
    this.modelMaxWidthForMobileDevice = windowWidth > 1200 ? '1140px' : windowWidth > 992 ? '960px' : '720px';
    this.modelWidthForMobileDevice = windowWidth > 1200 ? '70%' : windowWidth > 992 ? '80%' : windowWidth > 767 ? '90%' : '100%';
    this.hideForTabletAndBelow = windowWidth <= 800;
    this.hideForMobile = windowWidth < 576;

    this.graphWidthForMobileDevice = windowWidth > 1200 ? '800px' : windowWidth > 992 ? '700px' : windowWidth > 767 ? '500px' : '250px';

    this.modelMaxWidthIfScreenSize = windowWidth > this.minScreenSize.xxl1400.size ? this.minScreenSize.xxl1400.value : windowWidth > this.minScreenSize.xl1200.size ? this.minScreenSize.xl1200.value : windowWidth > this.minScreenSize.lg992.size ? this.minScreenSize.lg992.value : windowWidth > this.minScreenSize.md768.size ? this.minScreenSize.md768.value : windowWidth > this.minScreenSize.sm576.size ? this.minScreenSize.sm576.value : this.minScreenSize.defaultMobile.value;

    this.modelMaxWidth1300AndBelow = windowWidth > this.minScreenSize.xxl1300.size ? this.minScreenSize.xxl1300.value : windowWidth > this.minScreenSize.xl1200.size ? this.minScreenSize.xl1200.value : windowWidth > this.minScreenSize.lg992.size ? this.minScreenSize.lg992.value : windowWidth > this.minScreenSize.md768.size ? this.minScreenSize.md768.value : windowWidth > this.minScreenSize.sm576.size ? this.minScreenSize.sm576.value : this.minScreenSize.defaultMobile.value;

    this.modelMaxWidth1200AndBelow = windowWidth > this.minScreenSize.xl1200.size ? this.minScreenSize.xl1200.value : windowWidth > this.minScreenSize.lg992.size ? this.minScreenSize.lg992.value : windowWidth > this.minScreenSize.md768.size ? this.minScreenSize.md768.value : windowWidth > this.minScreenSize.sm576.size ? this.minScreenSize.sm576.value : this.minScreenSize.defaultMobile.value;

    this.modelMaxWidth992AndBelow = windowWidth > this.minScreenSize.lg992.size ? this.minScreenSize.lg992.value : windowWidth > this.minScreenSize.md768.size ? this.minScreenSize.md768.value : windowWidth > this.minScreenSize.sm576.size ? this.minScreenSize.sm576.value : this.minScreenSize.defaultMobile.value;

    // console.log('this.modelMaxWidthIfScreenSize ------- ', windowWidth +' ------- '+this.modelMaxWidthIfScreenSize);
  }

  chartResizeFn(chartEmpTaskStatus: any) {
    window.addEventListener('resize', () => {
      if (chartEmpTaskStatus) chartEmpTaskStatus?.resize();
    });
  }
}
